(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["careers-positions"]) return;
  try {
    
  jQuery(document).ready(function($){
    function runFAQ(){
      var toggleBlocks = $('.toggle-block');
      console.log(toggleBlocks);

      if(toggleBlocks){
        toggleBlocks.each(function(){
          $(this).find('.toggle-trigger').click(function(){
            if($(this).closest('.toggle-block').hasClass('toggled')){
              $(this).parents('.available-positions-wrapper').find('.toggle-block.toggled').find('.toggle-item').fadeToggle('fast');
              $(this).parents('.available-positions-wrapper').find('.toggle-block').removeClass('toggled');
            } else {
              $(this).parents('.available-positions-wrapper').find('.toggle-block.toggled').find('.toggle-item').fadeToggle('fast');
              $(this).parents('.available-positions-wrapper').find('.toggle-block').removeClass('toggled');

              if($(this).parent().hasClass('toggled')){
                $(this).parent().removeClass('toggled')
              } else {
                $(this).parent().addClass('toggled')
              }
              $(this).next('.toggle-item').fadeToggle('fast');
            }
          })
        });
      }
    }

    runFAQ();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare-template"]) return;
  try {
    
  var dragging = false,
        scrolling = false,
        resizing = false;
    //cache jQuery objects
    var imageComparisonContainers = $('.cd-image-container');
    //check if the .cd-image-container is in the viewport 
    //if yes, animate it
    checkPosition(imageComparisonContainers);
    $(window).on('scroll', function(){
        if( !scrolling) {
            scrolling =  true;
            ( !window.requestAnimationFrame )
                ? setTimeout(function(){checkPosition(imageComparisonContainers);}, 100)
                : requestAnimationFrame(function(){checkPosition(imageComparisonContainers);});
        }
    });

    //make the .cd-handle element draggable and modify .cd-resize-img width according to its position
    imageComparisonContainers.each(function(){
        var actual = $(this);
        drags(actual.find('.cd-handle'), actual.find('.cd-resize-img'), actual, actual.find('.cd-image-label[data-type="original"]'), actual.find('.cd-image-label[data-type="modified"]'));
    });

    //upadate images label visibility
    $(window).on('resize', function(){
        if( !resizing) {
            resizing =  true;
            ( !window.requestAnimationFrame )
                ? setTimeout(function(){checkLabel(imageComparisonContainers);}, 100)
                : requestAnimationFrame(function(){checkLabel(imageComparisonContainers);});
        }
    });

    function checkPosition(container) {
        container.each(function(){
            var actualContainer = $(this);
            if( $(window).scrollTop() + $(window).height()*0.5 > actualContainer.offset().top) {
                actualContainer.addClass('is-visible');
            }
        });

        scrolling = false;
    }

    function checkLabel(container) {
        container.each(function(){
            var actual = $(this);
            updateLabel(actual.find('.cd-image-label[data-type="modified"]'), actual.find('.cd-resize-img'), 'left');
            updateLabel(actual.find('.cd-image-label[data-type="original"]'), actual.find('.cd-resize-img'), 'right');
        });

        resizing = false;
    }

    //draggable funtionality - credits to http://css-tricks.com/snippets/jquery/draggable-without-jquery-ui/
    function drags(dragElement, resizeElement, container, labelContainer, labelResizeElement) {
        dragElement.on("mousedown vmousedown", function(e) {
            dragElement.addClass('draggable');
            resizeElement.addClass('resizable');

            var dragWidth = dragElement.outerWidth(),
                xPosition = dragElement.offset().left + dragWidth - e.pageX,
                containerOffset = container.offset().left,
                containerWidth = container.outerWidth(),
                minLeft = containerOffset + 10,
                maxLeft = containerOffset + containerWidth - dragWidth - 10;
            
            dragElement.parents().on("mousemove vmousemove", function(e) {
                if( !dragging) {
                    dragging =  true;
                    ( !window.requestAnimationFrame )
                        ? setTimeout(function(){animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);}, 100)
                        : requestAnimationFrame(function(){animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);});
                }
            }).on("mouseup vmouseup", function(e){
                dragElement.removeClass('draggable');
                resizeElement.removeClass('resizable');
            });
            e.preventDefault();
        }).on("mouseup vmouseup", function(e) {
            dragElement.removeClass('draggable');
            resizeElement.removeClass('resizable');
        });
    }

    function animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement) {
        var leftValue = e.pageX + xPosition - dragWidth;   
        //constrain the draggable element to move inside his container
        if(leftValue < minLeft ) {
            leftValue = minLeft;
        } else if ( leftValue > maxLeft) {
            leftValue = maxLeft;
        }

        var widthValue = (leftValue + dragWidth/2 - containerOffset)*100/containerWidth+'%';
        
        $('.cd-handle.draggable').css('left', widthValue).on("mouseup vmouseup", function() {
            $(this).removeClass('draggable');
            resizeElement.removeClass('resizable');
        });

        $('.resizable').css('width', widthValue); 

        updateLabel(labelResizeElement, resizeElement, 'left');
        updateLabel(labelContainer, resizeElement, 'right');
        dragging =  false;
    }

    function updateLabel(label, resizeElement, position) {
        if(position == 'left') {
            ( label.offset().left + label.outerWidth() < resizeElement.offset().left + resizeElement.outerWidth() ) ? label.removeClass('is-hidden') : label.addClass('is-hidden') ;
        } else {
            ( label.offset().left > resizeElement.offset().left + resizeElement.outerWidth() ) ? label.removeClass('is-hidden') : label.addClass('is-hidden') ;
        }
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare"] && !Shopify.designMode) return;
  try {
    
  var dragging = false,
        scrolling = false,
        resizing = false;
    //cache jQuery objects
    var imageComparisonContainers = $('.cd-image-container');
    //check if the .cd-image-container is in the viewport 
    //if yes, animate it
    checkPosition(imageComparisonContainers);
    $(window).on('scroll', function(){
        if( !scrolling) {
            scrolling =  true;
            ( !window.requestAnimationFrame )
                ? setTimeout(function(){checkPosition(imageComparisonContainers);}, 100)
                : requestAnimationFrame(function(){checkPosition(imageComparisonContainers);});
        }
    });

    //make the .cd-handle element draggable and modify .cd-resize-img width according to its position
    imageComparisonContainers.each(function(){
        var actual = $(this);
        drags(actual.find('.cd-handle'), actual.find('.cd-resize-img'), actual, actual.find('.cd-image-label[data-type="original"]'), actual.find('.cd-image-label[data-type="modified"]'));
    });

    //upadate images label visibility
    $(window).on('resize', function(){
        if( !resizing) {
            resizing =  true;
            ( !window.requestAnimationFrame )
                ? setTimeout(function(){checkLabel(imageComparisonContainers);}, 100)
                : requestAnimationFrame(function(){checkLabel(imageComparisonContainers);});
        }
    });

    function checkPosition(container) {
        container.each(function(){
            var actualContainer = $(this);
            if( $(window).scrollTop() + $(window).height()*0.5 > actualContainer.offset().top) {
                actualContainer.addClass('is-visible');
            }
        });

        scrolling = false;
    }

    function checkLabel(container) {
        container.each(function(){
            var actual = $(this);
            updateLabel(actual.find('.cd-image-label[data-type="modified"]'), actual.find('.cd-resize-img'), 'left');
            updateLabel(actual.find('.cd-image-label[data-type="original"]'), actual.find('.cd-resize-img'), 'right');
        });

        resizing = false;
    }

    //draggable funtionality - credits to http://css-tricks.com/snippets/jquery/draggable-without-jquery-ui/
    function drags(dragElement, resizeElement, container, labelContainer, labelResizeElement) {
        dragElement.on("mousedown vmousedown", function(e) {
            dragElement.addClass('draggable');
            resizeElement.addClass('resizable');

            var dragWidth = dragElement.outerWidth(),
                xPosition = dragElement.offset().left + dragWidth - e.pageX,
                containerOffset = container.offset().left,
                containerWidth = container.outerWidth(),
                minLeft = containerOffset + 10,
                maxLeft = containerOffset + containerWidth - dragWidth - 10;
            
            dragElement.parents().on("mousemove vmousemove", function(e) {
                if( !dragging) {
                    dragging =  true;
                    ( !window.requestAnimationFrame )
                        ? setTimeout(function(){animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);}, 100)
                        : requestAnimationFrame(function(){animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);});
                }
            }).on("mouseup vmouseup", function(e){
                dragElement.removeClass('draggable');
                resizeElement.removeClass('resizable');
            });
            e.preventDefault();
        }).on("mouseup vmouseup", function(e) {
            dragElement.removeClass('draggable');
            resizeElement.removeClass('resizable');
        });
    }

    function animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement) {
        var leftValue = e.pageX + xPosition - dragWidth;   
        //constrain the draggable element to move inside his container
        if(leftValue < minLeft ) {
            leftValue = minLeft;
        } else if ( leftValue > maxLeft) {
            leftValue = maxLeft;
        }

        var widthValue = (leftValue + dragWidth/2 - containerOffset)*100/containerWidth+'%';
        
        $('.cd-handle.draggable').css('left', widthValue).on("mouseup vmouseup", function() {
            $(this).removeClass('draggable');
            resizeElement.removeClass('resizable');
        });

        $('.resizable').css('width', widthValue); 

        updateLabel(labelResizeElement, resizeElement, 'left');
        updateLabel(labelContainer, resizeElement, 'right');
        dragging =  false;
    }

    function updateLabel(label, resizeElement, position) {
        if(position == 'left') {
            ( label.offset().left + label.outerWidth() < resizeElement.offset().left + resizeElement.outerWidth() ) ? label.removeClass('is-hidden') : label.addClass('is-hidden') ;
        } else {
            ( label.offset().left > resizeElement.offset().left + resizeElement.outerWidth() ) ? label.removeClass('is-hidden') : label.addClass('is-hidden') ;
        }
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"]) return;
  try {
    
  jQuery(document).ready(function($){
    function runFAQ(){
		var toggleBlocks = $('.toggle-block');

		if(toggleBlocks){
			toggleBlocks.each(function(){
				$(this).find('.toggle-trigger').click(function(){
					if($(this).closest('.toggle-block').hasClass('toggled')){
						$(this).parents('.page-faq-wrapper').find('.toggle-block.toggled').find('.toggle-item').fadeToggle('fast');
						$(this).parents('.page-faq-wrapper').find('.toggle-block').removeClass('toggled');
					} else {
						$(this).parents('.page-faq-wrapper').find('.toggle-block.toggled').find('.toggle-item').fadeToggle('fast');
						$(this).parents('.page-faq-wrapper').find('.toggle-block').removeClass('toggled');

						if($(this).parent().hasClass('toggled')){
							$(this).parent().removeClass('toggled')
						} else {
							$(this).parent().addClass('toggled')
						}
						$(this).next('.toggle-item').fadeToggle('fast');
					}
				})
			});
		}
	}
	runFAQ();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-video"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function($){
    function sizeVid(){
      var v = $('#video');
      var vc = v.closest('.video-container');
      var vcw = vc.width();
      v.width(vcw);
      v.height(vcw * 0.56);
    }

    sizeVid();

    $(window).resize(function(){
      console.log('test');
      sizeVid();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["old-product-template-compare"]) return;
  try {
    
  jQuery(document).ready(function($){
    function runComparison(){
      var afterFront = $('#ProductThumbs-product-template-compare img[data-position=0]');
      var beforeFront = $('#ProductThumbs-product-template-compare img[data-position=1]');
      var afterBack = $('#ProductThumbs-product-template-compare img[data-position=2]');
      var beforeBack = $('#ProductThumbs-product-template-compare img[data-position=3]');
      var lastItem = $('#ProductThumbs-product-template-compare img').last();
      var lastItemIndex = lastItem.data('position');
      var compareFront = $('#compare-front');
      var compareBack = $('#compare-back');
      var compareFrontBefore = compareFront.find('.cd-compare-before');
      var compareFrontAfter = compareFront.find('.cd-compare-after');
      var compareBackBefore = compareBack.find('.cd-compare-before');
      var compareBackAfter = compareBack.find('.cd-compare-after');

      compareFrontBefore.attr('src',beforeFront.data('compare'));
      compareFrontAfter.attr('src',afterFront.data('compare'));
      compareBackBefore.attr('src',beforeBack.data('compare'));
      compareBackAfter.attr('src',afterBack.data('compare'));

      $('#ProductThumbs-product-template-compare img[data-position='+(lastItemIndex-1)+']').addClass('toggle-compare toggle-front');
      lastItem.addClass('toggle-compare toggle-back');

      beforeFront.hide();
      beforeBack.hide();

      $('#ProductThumbs-product-template-compare img').click(function(){
        if(!$(this).hasClass('toggle-compare')){
          $('.featured-container').show();
          compareFront.hide();
          compareBack.hide();
        } else {
          $('.featured-container').hide();

          if($(this).hasClass('toggle-front')){
            compareBack.hide();
            compareFront.show();
          } else {
            compareFront.hide();
            compareBack.show();
          }
        }
      });
    }
    runComparison();


var dragging = false,
        scrolling = false,
        resizing = false;
    //cache jQuery objects
    var imageComparisonContainers = $('.cd-image-container');
    //check if the .cd-image-container is in the viewport 
    //if yes, animate it
    checkPosition(imageComparisonContainers);
    $(window).on('scroll', function(){
        if( !scrolling) {
            scrolling =  true;
            ( !window.requestAnimationFrame )
                ? setTimeout(function(){checkPosition(imageComparisonContainers);}, 100)
                : requestAnimationFrame(function(){checkPosition(imageComparisonContainers);});
        }
    });

    //make the .cd-handle element draggable and modify .cd-resize-img width according to its position
    imageComparisonContainers.each(function(){
        var actual = $(this);
        drags(actual.find('.cd-handle'), actual.find('.cd-resize-img'), actual, actual.find('.cd-image-label[data-type="original"]'), actual.find('.cd-image-label[data-type="modified"]'));
    });

    //upadate images label visibility
    $(window).on('resize', function(){
        if( !resizing) {
            resizing =  true;
            ( !window.requestAnimationFrame )
                ? setTimeout(function(){checkLabel(imageComparisonContainers);}, 100)
                : requestAnimationFrame(function(){checkLabel(imageComparisonContainers);});
        }
    });

    function checkPosition(container) {
        container.each(function(){
            var actualContainer = $(this);
            if( $(window).scrollTop() + $(window).height()*0.5 > actualContainer.offset().top) {
                actualContainer.addClass('is-visible');
            }
        });

        scrolling = false;
    }

    function checkLabel(container) {
        container.each(function(){
            var actual = $(this);
            updateLabel(actual.find('.cd-image-label[data-type="modified"]'), actual.find('.cd-resize-img'), 'left');
            updateLabel(actual.find('.cd-image-label[data-type="original"]'), actual.find('.cd-resize-img'), 'right');
        });

        resizing = false;
    }

    //draggable funtionality - credits to http://css-tricks.com/snippets/jquery/draggable-without-jquery-ui/
    function drags(dragElement, resizeElement, container, labelContainer, labelResizeElement) {
        dragElement.on("mousedown vmousedown", function(e) {
            dragElement.addClass('draggable');
            resizeElement.addClass('resizable');

            var dragWidth = dragElement.outerWidth(),
                xPosition = dragElement.offset().left + dragWidth - e.pageX,
                containerOffset = container.offset().left,
                containerWidth = container.outerWidth(),
                minLeft = containerOffset + 10,
                maxLeft = containerOffset + containerWidth - dragWidth - 10;
            
            dragElement.parents().on("mousemove vmousemove", function(e) {
                if( !dragging) {
                    dragging =  true;
                    ( !window.requestAnimationFrame )
                        ? setTimeout(function(){animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);}, 100)
                        : requestAnimationFrame(function(){animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement);});
                }
            }).on("mouseup vmouseup", function(e){
                dragElement.removeClass('draggable');
                resizeElement.removeClass('resizable');
            });
            e.preventDefault();
        }).on("mouseup vmouseup", function(e) {
            dragElement.removeClass('draggable');
            resizeElement.removeClass('resizable');
        });
    }

    function animateDraggedHandle(e, xPosition, dragWidth, minLeft, maxLeft, containerOffset, containerWidth, resizeElement, labelContainer, labelResizeElement) {
        var leftValue = e.pageX + xPosition - dragWidth;   
        //constrain the draggable element to move inside his container
        if(leftValue < minLeft ) {
            leftValue = minLeft;
        } else if ( leftValue > maxLeft) {
            leftValue = maxLeft;
        }

        var widthValue = (leftValue + dragWidth/2 - containerOffset)*100/containerWidth+'%';
        
        $('.cd-handle.draggable').css('left', widthValue).on("mouseup vmouseup", function() {
            $(this).removeClass('draggable');
            resizeElement.removeClass('resizable');
        });

        $('.resizable').css('width', widthValue); 

        updateLabel(labelResizeElement, resizeElement, 'left');
        updateLabel(labelContainer, resizeElement, 'right');
        dragging =  false;
    }

    function updateLabel(label, resizeElement, position) {
        if(position == 'left') {
            ( label.offset().left + label.outerWidth() < resizeElement.offset().left + resizeElement.outerWidth() ) ? label.removeClass('is-hidden') : label.addClass('is-hidden') ;
        } else {
            ( label.offset().left > resizeElement.offset().left + resizeElement.outerWidth() ) ? label.removeClass('is-hidden') : label.addClass('is-hidden') ;
        }
    }




    function hideModal(){
      $('.modal-close').click(function(){
        $('.modal').css({
          'display': 'none'
        });
      });
    }

    function showModal(elem){
      $('.'+elem).css({
        'display': 'flex'
      });

      hideModal();
    }

    $('.step-one').click(function(){
      showModal('modal-1');
    });

    $('.step-two').click(function(){
      showModal('modal-2');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-template"]) return;
  try {
    
    jQuery(document).ready(function($){
        var counter = $('#counter').data('counter');
        var countDownDate = new Date(counter).getTime();
        var now = new Date().getTime();

        function getTimeLeft() {
            // Find the distance between now an the count down date
            var distance = countDownDate - now;

            // Time calculations for days, hours, minutes and seconds
            var days = Math.floor(distance / (1000 * 60 * 60 * 24));
            var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((distance % (1000 * 60)) / 1000);

            var daysArray = (""+days).split("");
            var daysStr = '';

            // Display the result in the element with id="demo"
            for(var i = 0; i < daysArray.length; i++){
                daysStr += '<div class="counter-digit flex align-center justify-center">'+daysArray[i]+'</div>';
            }
            document.getElementById("counter").innerHTML = daysStr;

            // If the count down is finished, write some text 
            if (distance < 0) {
                clearInterval(x);
                document.getElementById("counter").innerHTML = "EXPIRED";
            }
        }

        getTimeLeft();

        setInterval(function(){ 
		  	getTimeLeft();
        }, 86400000);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-in-action"]) return;
  try {
    
  jQuery(document).ready(function($){
    /*
    $('.product-in-action-slider').slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 960,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 720,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }
      ]
    });
    */
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promos"]) return;
  try {
    
  jQuery(document).ready(function($){
    var popup = $('.popup-modal');
    var delay = popup.data('delay');
    var showAgain = popup.data('show-again');
    var hidePopup = $.cookie('hide_subscribe');

    function show_subscribe(){
      if(hidePopup != 'true') {
        popup.fadeIn();
      }
    }

    setTimeout(show_subscribe, delay);
  
    $('#popup-close').click(function(e){
      e.preventDefault();
      popup.fadeOut();
    });

    $.cookie('hide_subscribe', 'true', { expires: showAgain, path: '/' });

    $('*[data-section-id="promos"]').css({ background: '#FBD7D0' });

    var InfiniteRotator =
    {
        init: function()
        {
            //initial fade-in time (in milliseconds)
            var initialFadeIn = 0;
 
            //interval between items (in milliseconds)
            var itemInterval = ($('.rotate-bar').data('rotate-speed')*1000);
 
            //cross-fade time (in milliseconds)
            var fadeTime = 500;
 
            //count number of items
            var numberOfItems = $('.rotate-bar').length;
 
            //set current item
            var currentItem = 0;
 
            //show first item
            $('.rotate-bar').eq(currentItem).toggleClass('rotate-show').find('.promo-bar-text').fadeIn(initialFadeIn);

            function rotateItems(){
              $('.rotate-bar').eq(currentItem).toggleClass('rotate-show').find('.promo-bar-text').fadeOut(fadeTime);
 
              if(currentItem == numberOfItems -1){
                  currentItem = 0;
              }else{
                  currentItem++;
              }

              $('.rotate-bar').eq(currentItem).toggleClass('rotate-show').find('.promo-bar-text').fadeIn(fadeTime);
            }
 
            //loop through the items
            var infiniteLoop = setInterval(function(){
              rotateItems();
            }, itemInterval);
        }
    };
 
    InfiniteRotator.init();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["references"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function($){
  $('.references-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.references-nav'
  });
  $('.references-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.references-for',
    arrows: false,
    dots: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sizing-charts-template"]) return;
  try {
    
    jQuery(function($){
        function runTabSection(){
            tabs = $('.smash-tab');
            codes = $('.smash-tab-content');

            codes.hide();
            $('.smash-tab-content.toggled').show();

            tabs.click(function(){
                tabID = $(this).data('count');

                $('.smash-tabs').find('.active-tab').removeClass('active-tab');
                $(this).addClass('active-tab');

                $('.smash-tabs-content-wrap').find('.smash-tab-content.toggled').removeClass('toggled').fadeOut('fast', function(){
                    $('.smash-tabs-content-wrap').find('.smash-tab-content[data-count="' + tabID + '"]').fadeIn('fast').addClass('toggled');
                });

            });
        }
        runTabSection();
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smash-slider-best-sellers-1"]) return;
  try {
    
jQuery(document).ready(function($){
  function runSlider(){
    $('.smash-slider').slick({
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
  }
  runSlider();

  function trimReviewCount() {
        var reviews = $('.spr-badge');

        reviews.each(function(){
            var caption = $(this).find('.spr-badge-caption');
            var num = caption.text().split(' ')[0]; 
            var numParsed = parseInt(num);

            if(numParsed){
                caption.text('('+num+')');
            } else {
                caption.text('(0)');
            }
        });
    }

    setTimeout(trimReviewCount, 2000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smash-slider-best-sellers-2"]) return;
  try {
    
jQuery(document).ready(function($){
  function runSlider(){
    $('.smash-slider').slick({
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
  }
  runSlider();

  function trimReviewCount() {
        var reviews = $('.spr-badge');

        reviews.each(function(){
            var caption = $(this).find('.spr-badge-caption');
            var num = caption.text().split(' ')[0]; 
            var numParsed = parseInt(num);

            if(numParsed){
                caption.text('('+num+')');
            } else {
                caption.text('(0)');
            }
        });
    }

    setTimeout(trimReviewCount, 2000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smash-slider-best-sellers-3"]) return;
  try {
    
jQuery(document).ready(function($){
  function runSlider(){
    $('.smash-slider').slick({
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });
  }
  runSlider();

  function trimReviewCount() {
        var reviews = $('.spr-badge');

        reviews.each(function(){
            var caption = $(this).find('.spr-badge-caption');
            var num = caption.text().split(' ')[0]; 
            var numParsed = parseInt(num);

            if(numParsed){
                caption.text('('+num+')');
            } else {
                caption.text('(0)');
            }
        });
    }

    setTimeout(trimReviewCount, 2000);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smash-slider"] && !Shopify.designMode) return;
  try {
    
jQuery(document).ready(function($){
  function runSlider(){
    $('.smash-slider').slick({
        responsive: [
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    });
  }
  runSlider();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["support-list"]) return;
  try {
    
  jQuery(document).ready(function($){
    $('.faq-section-wrapper').accordion({
      collapsible: true,
      heightStyle: "content"
    });

    var checkForTags = function() {
      var tag = getUrlParameter('tag');
      var tagU = tag.split('-').join(' ');

      if(tagU) {
        $('.tag-title').html(tagU);
      }
    }

    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    };

    setTimeout(function(){ 
      checkForTags();
    }, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-careers"]) return;
  try {
    
  jQuery(document).ready(function($){
    function sizeVid(){
      var v = $('#video');
      var vc = v.closest('.video-wrapper');
      var vcw = vc.width();
      v.width(vcw);
      v.height(vcw * 0.56);
    }

    sizeVid();

    $(window).resize(function(){
      console.log('test');
      sizeVid();
    });
  });

  } catch(e) { console.error(e); }
})();
})();
